import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = `${apiMainUrl}logs`;

// Fetch grouped executions with filters + paging.
const getLogs = async (token, {
  category = '',
  processType = '',
  status = '',
  search = '',
  scheduledJobId = '',
  sortBy = '',
  sortDir = '',
  page = 1,
  pageSize = 50
} = {}) => {
  try {
    const params = { page, pageSize };
    if (category) params.category = category;
    if (processType) params.processType = processType;
    if (status) params.status = status;
    if (search) params.search = search;
    if (scheduledJobId) params.scheduledJobId = scheduledJobId;
    if (sortBy) params.sortBy = sortBy;
    if (sortDir) params.sortDir = sortDir;

    const response = await axios.get(`${API_BASE_URL}`, {
      headers: { 'Authorization': `Bearer ${token}` },
      params
    });
    return response.data; // { items: grouped executions, total }
  } catch (error) {
    console.error('Failed to fetch logs:', error);
    throw error;
  }
};

export const LogsDataService = {
  getLogs
};
